function Jordan({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1430)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M9.73908 10.4348H31.0047C28.7441 4.342 22.8793 0 15.9999 0C11.5816 0 7.58202 1.79119 4.68677 4.68681L9.73908 10.4348Z" fill="black"/>
  <path d="M9.73908 21.5654H31.0047C28.7441 27.6582 22.8793 32.0002 15.9999 32.0002C11.5816 32.0002 7.58202 30.2091 4.68677 27.3134L9.73908 21.5654Z" fill="#6DA544"/>
  <path d="M4.68628 4.68652C-1.56209 10.9349 -1.56209 21.0656 4.68628 27.314C7.26834 24.732 9.75165 22.2486 16 16.0003L4.68628 4.68652Z" fill="#D80027"/>
  <path d="M6.35028 12.5215L7.22834 14.3577L9.2114 13.8994L8.32328 15.7307L9.91796 16.9953L7.93253 17.4427L7.93803 19.478L6.35028 18.2047L4.76247 19.478L4.76803 17.4427L2.78259 16.9953L4.37722 15.7307L3.48922 13.8994L5.47215 14.3577L6.35028 12.5215Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Jordan;
